import React from "react";
import SimpleContent from "components/Structure/ModalManager/SimpleContent.js";
import Button from "components/Elements/Button/Button.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";

const BrandingRemoveModal = ({ titleModal, loading, handleClick }) => {
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();
  return (
    <SimpleContent
      title={titleModal}
      message={null}
      actionButton={
        loading ? (
          <LoadingImageElement />
        ) : (
          <Button className="new-button" onClick={() => handleClick()}>
            {getTextByKey("ok")}
          </Button>
        )
      }
      exitButton={
        loading ? null : (
          <Button
            blank
            className="new-button new-blank"
            onClick={() => closeModal()}
          >
            {getTextByKey("cancel")}
          </Button>
        )
      }
    ></SimpleContent>
  );
};

export default BrandingRemoveModal;
